import { jsx as _jsx } from "react/jsx-runtime";
import Icon from "@/components/icon/Icon";
import { ArrowLeft, Sizes } from "@/components/icon/IconList";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { Button } from "@bookips/solvook-ui-library";
import { styled, useTheme } from "@mui/material";
import { useRouter } from "next/router";
export const PrevButton = ()=>{
    const theme = useTheme();
    const router = useRouter();
    return /*#__PURE__*/ _jsx(PrevButtonStyle, {
        label: "이전",
        size: "xsmall",
        startIcon: /*#__PURE__*/ _jsx(Icon, {
            icon: ArrowLeft,
            size: Sizes.smallHalf,
            color: theme.palette.grey[500]
        }),
        variant: "text",
        onClick: ()=>{
            //mx-190 이전버튼 클릭시
            mixpanelEvent("Back button Clicked", {
                "Button Type": "브랜드 홈",
                "Button Name": "이전"
            });
            router.beforePopState((state)=>{
                state.options.scroll = false;
                return true;
            });
            router.back();
        }
    });
};
const PrevButtonStyle = styled(Button)((param)=>{
    let { theme  } = param;
    return {
        width: "fit-content",
        minWidth: "fit-content",
        gap: "4px",
        alignItems: "baseline",
        fontSize: "14px",
        ...theme.typography.subtitle2,
        color: theme.palette.grey[500],
        ":hover": {
            color: theme.palette.grey[700],
            textDecoration: "underline",
            textEmphasisPosition: "from-font"
        }
    };
});
